"use client";

import React from "react";
import Loading from "@/app/loading";
import useDesign from "./Design.hook";
import styles from "./Design.module.scss";
import DesignPreview from "./DesignPreview";
import PartSelect from "./PartSelect";

type Props = {
	bodyId: string | undefined;
	editingBody: any;
	partNames: any;
};

/**
 * 新規作成 コンポーネント
 * @returns {JSX.Element} 新規作成 コンポーネント
 */

export default function Design(props: Props) {
	const { bodyId, editingBody, partNames } = props;

	const {
		showPalette,
		showPartMove,
		isLoading,
		setShowPalette,
		setShowPartMove,
	} = useDesign({
		editingBody,
		partNames,
	});

	if (isLoading) {
		return <Loading></Loading>;
	}

	return (
		<div className={styles.container}>
			<DesignPreview
				bodyId={bodyId}
				setShowPalette={setShowPalette}
				setShowPartMove={setShowPartMove}
				showPalette={showPalette}
				showPartMove={showPartMove}
			/>
			<PartSelect
				setShowPalette={setShowPalette}
				setShowPartMove={setShowPartMove}
				showPalette={showPalette}
				showPartMove={showPartMove}
			/>
		</div>
	);
}
